export function assertUnreachable(context: string, x: never): never {
	throw new Error(
		"That's unreachable code. Unrecoginzed value for " + context + ': ' + x
	)
}
